// extracted by mini-css-extract-plugin
export default {"container":"box_container__vpq7J"};